// sidebarItems.js
import DashboardIcon from "../image/Dashboards.png";
import MasterDataIcon from "../image/MasterData.png";
import MyProfileIcon from "../image/MyProfile.png"
import HistoryIcon  from "../image/History.svg";
import IntelligenceIcon from "../image/Analytics.png";



export const sidebarItems = [
  
  {
    title: "Dashboard",
    icon: DashboardIcon,
    path: "/",
    roles: [
      "Manager",
      "Admin",
      
    ],
  },
  // ================= ADMIN =================
  {
    title: "Master Data",
    icon: MasterDataIcon,
    roles: ["Manager", "Admin"],
    submenus: [
      { title: "Category", path: "/master-data/categories" },
      {
        title: "Units",
        path: "/master-data/unit",
      },
      { title: "Products", path: "/master-data/products" },
      { title: "Input Purchases", path: "/master-data/input-purchases" },
        { title: "User Master", path: "/master-data/user-master" },
         
    ],
  },
  {
    title: "Intelligence",
    icon: IntelligenceIcon,
    path: "/intelligence",
    roles: ["Admin", "Manager"],
  },
  {
    title: "History",
    icon: HistoryIcon,
    path: "/history",
    roles: [
      "Admin",
      "Manager",
      
    ],
  },

  {
    title: "My Profile",
    icon: MyProfileIcon,
    path: "/my-profile",
    roles: [
      "Admin",
      "Manager",
      
    ],
  },
];
